import React, { ButtonHTMLAttributes, FC, ReactElement } from 'react';
import styles from './index.module.scss';
import classNames from 'classnames';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text: string,
  icon?: ReactElement,
  onClick: () => void;
}

const Button: FC<ButtonProps> = (props) => {
  const {
    icon,
    text,
    onClick,
    className, // 接收 className
    ...rest // 其他属性
  } = props;
  
  return (
    <button 
      {...rest} 
      className={classNames(styles.commonButton, className)} // 合并 className
      onClick={onClick}
    >
      {icon && <span className={styles.icon}>{icon}</span>}
      <span className={styles.text}>{text}</span>
    </button>
  );
};

export default Button;